import { FC, Dispatch, SetStateAction } from 'react'
import StandardInput from 'src/components/basic/StandardInput'
import StandardSelect from 'src/components/basic/StandardSelect'
import StandardFormatInput from 'src/components/basic/StandardFormatInput'
import Button from 'src/components/basic/Button'
import {
  FormContainer,
} from 'src/components/application/defaultComponents'
import {
  FlexDiv
} from 'src/components/application/formComponents/styles'
import QuestionItemGeneralLayout from '../../formComponents/QuestionItemGeneralLayout'
import { JudgeInsuranceDataWithId } from 'src/dtos/custom'
import { previousLiabilityLimits } from 'src/constants/application'
import { validateMonthYearField } from 'src/utils/formDataManipulation'

interface Props {
  insurancesData: JudgeInsuranceDataWithId[];
  setInsurancesData: Dispatch<SetStateAction<JudgeInsuranceDataWithId[]>>;
  isIncorrect: boolean;
}

const BasicForm: FC<Props> = ({
  insurancesData,
  setInsurancesData,
  isIncorrect
}) => {
  const handleInsuranceChange = (index: number, update: Partial<JudgeInsuranceDataWithId>) => {
    setInsurancesData(prev => prev.map((ins, idx) => idx === index ? { ...ins, ...update } : ins))
  }

  const handleRemoveInsurer = (index: number) => {
    setInsurancesData(prev => prev.filter((ins, idx) => idx !== index))
  }

  return (
    <FormContainer maxWidth='624px'>
      {insurancesData.map((insurance, index) => (
        <QuestionItemGeneralLayout
          key={insurance.id}
          step={index + 1}
          title={index === 0 ? 'Most Recent Insurance' : 'Prior Insurance'}
          leftBar
        >
          <StandardInput
            label="Insurance Company"
            value={insurance?.insuranceCompany ?? ''}
            onChange={({ target: { value }}) => handleInsuranceChange(index, { insuranceCompany: value })}
            isIncorrect={isIncorrect && !insurance?.insuranceCompany}
            errorMessage={isIncorrect && !insurance?.insuranceCompany ? 'This is a required field' : ''}
          />
          <StandardSelect
            label='Limits of Liability'
            value={insurance?.liabilityLimits ?? ''}
            onChange={({ target: { value }}) => handleInsuranceChange(index, { liabilityLimits: value })}
            isIncorrect={isIncorrect && !insurance?.liabilityLimits}
            errorMessage={isIncorrect && !insurance?.liabilityLimits ? 'This is a required field' : ''}
          >
            <option value="" disabled>Select</option>
            {previousLiabilityLimits.map((pt, index) => (
              <option key={index} value={pt}>{pt}</option>
            ))}
          </StandardSelect>
          <FlexDiv dir="column" gap="24px">
            <strong>Effective Dates (Optional)</strong>
            <FlexDiv gap="24px">
              <StandardFormatInput
                label="From"
                labelSize='small'
                maskStyle='monthYear'
                leftIcon='calendar'
                value={insurance?.effectiveDateFrom}
                onValueChange={({formattedValue}) => handleInsuranceChange(index, { effectiveDateFrom: formattedValue })}
                isIncorrect={isIncorrect && !!insurance?.effectiveDateFrom && !!validateMonthYearField(insurance?.effectiveDateFrom, true)}
                errorMessage={isIncorrect && !!insurance?.effectiveDateFrom? validateMonthYearField(insurance?.effectiveDateFrom, true) : ''}
              />
              <StandardFormatInput
                label="To"
                labelSize='small'
                maskStyle='monthYear'
                leftIcon='calendar'
                value={insurance?.effectiveDateTo}
                onValueChange={({formattedValue}) => handleInsuranceChange(index, { effectiveDateTo: formattedValue })}
                isIncorrect={isIncorrect && !!insurance?.effectiveDateTo && !!validateMonthYearField(insurance?.effectiveDateTo, true)}
                errorMessage={isIncorrect && !!insurance?.effectiveDateTo? validateMonthYearField(insurance?.effectiveDateTo, true) : ''}
              />
            </FlexDiv>
          </FlexDiv>
          {index > 0 ? (
            <Button
              variant='error'
              onClick={() => handleRemoveInsurer(index)}
              padding="8px 70px"
            >
              Remove insurer
            </Button>
          ) : null}
        </QuestionItemGeneralLayout>
      ))}
    </FormContainer>
  )
}

export default BasicForm